<template>
  <span class="job-category-icon" :class="sizeClass">
    <img
      :src="src"
      alt=""
      width="16"
      height="16"
    />
  </span>
</template>

<script setup>
import { computed } from "vue";

import activeGlyph from "@components/assets/category-icon.svg";

/**
 * Job Category "grid" glyph (ER-11879). Mirrors JobFamilyIcon (ER-11386) so the
 * ChatterDrawer header renders the same way for categories as it does for families.
 * The active asset is the existing category-icon.svg export — not a redrawn path.
 */
const props = defineProps({
  color: {
    type: String,
    default: "dark",
  },
  size: {
    type: String,
    default: "normal",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const sizeClass = computed(() => `job-category-icon--${props.size}`);

const src = computed(() => activeGlyph);
</script>

<style scoped>
.job-category-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.job-category-icon--normal {
  width: 16px;
  height: 16px;
}

.job-category-icon img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
